import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { bizNow } from '@/utils/timesheetHelpers'

// Renders a header row + data rows (as produced for CSV export) into a
// landscape PDF table and triggers a browser download.
//
// `tz` is the timezone the "Generated by..." footer timestamp is shown in —
// defaults to BUSINESS_TZ (Perth) so an unpassed call behaves exactly as
// before. An export can span projects in more than one timezone (see
// docs/designs/per-site-timezones.md 1.10, which made the API's PDF footer
// use the first timesheet's project timezone for the same reason); callers
// that know a single relevant project/company timezone should pass it.
export function downloadRowsAsPdf(filename, rows, tz) {
  // eslint-disable-next-line new-cap
  const doc = new jsPDF({ orientation: 'landscape' })
  const [header, ...body] = rows

  doc.autoTable({
    head: [header],
    body,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [37, 99, 235] },
    margin: { top: 12, bottom: 14 },
    // autoTable paginates internally before returning, so a footer drawn
    // after the call would only land on the last page — didDrawPage fires
    // once per page as it's rendered, which is what puts it on every page.
    didDrawPage: (data) => {
      const pageHeight = doc.internal.pageSize.getHeight()
      doc.setFontSize(8)
      doc.setTextColor(120)
      doc.text(
        `Generated by Tradie Pass - ${bizNow(tz).format('DD/MM/YYYY h:mm A')}`,
        data.settings.margin.left,
        pageHeight - 6,
      )
    },
  })

  doc.save(filename + '.pdf')
}

// Encodes header + data rows (same shape as downloadRowsAsPdf) as CSV and
// triggers a browser download. The leading UTF-8 BOM makes Excel detect the
// encoding instead of mangling non-ASCII characters (e.g. accented names).
export function downloadRowsAsCsv(filename, rows) {
  const csv = rows
    .map((r) =>
      r.map((v) => '"' + String(v).replace(/"/g, '""') + '"').join(','),
    )
    .join('\n')

  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename + '.csv'
  a.click()
  URL.revokeObjectURL(url)
}
